import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from '@assetmark/ui-components';
import { SkeletonLayout } from '../layouts/Skeleton';
import styles from './ErrorPage.module.scss';
/**
 * Authentication pending page is shown when the application does not yet know
 * if the user is authenticated or not, and does not have a token. Therefore,
 * it cannot use the default layout, and exists outside the router context.
 * @constructor
 */
export const AuthenticationPendingPage = () => (_jsx(SkeletonLayout, { children: _jsx(ErrorPage, { className: styles.page, message: "Authenticating..." }) }));
